import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import { Link } from "react-router-dom";
import {SideBar} from "../SideBar/SideBar.js";

import { FaArrowRight } from "react-icons/fa"; 

const GalleryPanel = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryBackground, setGalleryBackground] = useState(null);
  const [file, setFile] = useState(null);
  const [editImageId, setEditImageId] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); 

  useEffect(() => {
    fetchGalleryData();
  }, []);

  const fetchGalleryData = async () => {
    try {
      const responseImages = await axiosInstance.get('/gallery/content');
      setGalleryImages(responseImages.data);

      const responseBackground = await axiosInstance.get('/gallery/bg');
      if (responseBackground.data.length > 0) {
        setGalleryBackground(responseBackground.data[0]); 
      }
    } catch (error) {
      console.error('Error fetching gallery data:', error);
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleImageUpload = async () => {
    if (!file) {
      alert('Please select an image file!');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('GalleryImage', file);

      const response = await axiosInstance.post('/gallery/content/upload', formData);
      setGalleryImages([...galleryImages, response.data]);
      setFile(null);
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  const handleBackgroundUpload = async () => {
    if (!file) {
      alert('Please select an image file!');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('BackgroundImage', file);

      const response = await axiosInstance.put(`/gallery/bg/${galleryBackground._id}`, formData);
      setGalleryBackground(response.data);
      setFile(null);
    } catch (error) {
      console.error('Error uploading background image:', error);
    }
  };

  const handleImageEdit = (imageId) => {
    setEditImageId(imageId);
    
  };

  const handleImageUpdate = async (imageId) => {
    if (!file) {
      alert('Please select an image file!');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('GalleryImage', file);

      const response = await axiosInstance.put(`/gallery/${imageId}`, formData);
      const updatedImages = galleryImages.map((image) =>
        image._id === imageId ? response.data : image
      );
      setGalleryImages(updatedImages);
      setEditImageId(null);
      setFile(null);
    } catch (error) {
      console.error('Error updating image:', error);
    }
  };

  const cancelImageEdit = () => {
    setEditImageId(null);
    setFile(null);
  };

  const handleImageDelete = async (imageId) => {
    try {
      await axiosInstance.delete(`/gallery/${imageId}`);
      const updatedImages = galleryImages.filter((image) => image._id !== imageId);
      setGalleryImages(updatedImages);
    } catch (error) {
      console.error('Error deleting image:', error);
    }
  };
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
<div className="flex ">
<SideBar />
      <div className="flex-1 h-screen p-6 overflow-auto bg-gray-100">
      <div className="max-w-3xl mx-auto panel-container" >
      <h2>Gallery Management</h2>
      {/* Gallery Background Section */}
      <div>
        <h3>Gallery Background</h3>
        {galleryBackground && (
          <div>
            <img src={galleryBackground.BackgroundImage} alt="Gallery Background" style={{ width: '100px', height: 'auto' }} />
            <input                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
type="file" onChange={handleFileChange} />
            <button onClick={handleBackgroundUpload}>Update Background</button>
          </div>
        )}
      </div>

      {/* Gallery Images Section */}
      <div>
        <h3>Gallery Images</h3>
        <input               className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="file" onChange={handleFileChange} />
        <button onClick={handleImageUpload}>Upload Image</button>

        <div>
          {galleryImages.map((image) => (
            <div key={image._id}>
              {editImageId === image._id ? (
                <div>
                  <input               className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="file" onChange={handleFileChange} />
                  <button                 className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
onClick={() => handleImageUpdate(image._id)}>Update</button>
                  <button                 className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 onClick={cancelImageEdit}>Cancel</button>
                </div>
              ) : (
                <div>
                  <img src={image.GalleryImage} alt="Gallery" style={{ width: '100px', height: 'auto' }} />
                  <button                  className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 onClick={() => handleImageEdit(image._id)}>Edit</button>
                  <button                 className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
  onClick={() => handleImageDelete(image._id)}>Delete</button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
      </div>
    </div>
  );
};

export default GalleryPanel;
